import React from 'react';
import cn from 'classnames';
import ServiceDetails from "../ServiceDetails/ServiceDetails";
import styles from "./ServicePanel.module.scss";
import { serviceModel } from "../../models";
export const getTestId = idx => "service-panel-".concat(idx, "-");
const ServicePanel = /*#__PURE__*/React.forwardRef(function ServicePanel(props, ref) {
  const {
    idx,
    service,
    useBadges,
    menu,
    ignoreAmendments,
    agreementStatus,
    agreementData,
    additionalSections,
    footer,
    disableEditBillUpfront,
    disableEditBillingDay,
    isVendor,
    disableStatusBadge,
    error,
    onCostChange,
    onHasError,
    onDayOfMonthChange,
    onDayOfWeekChange,
    onBillUpfrontModeChange
  } = props;
  const testid = getTestId(idx);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": "".concat(testid, "container-").concat(idx),
    "aria-invalid": error,
    className: cn(styles.mainContainer, {
      [styles.error]: error
    })
  }, /*#__PURE__*/React.createElement(ServiceDetails, {
    useBadges: useBadges,
    serviceType: service.status.type,
    serviceToDisplay: ignoreAmendments ? service : serviceModel.applyChanges(service),
    testid: testid,
    agreementStatus: agreementStatus,
    agreementData: agreementData,
    additionalSections: additionalSections,
    isVendor: isVendor,
    disableEditBillUpfront: disableEditBillUpfront,
    disableEditBillingDay: disableEditBillingDay,
    disableStatusBadge: disableStatusBadge,
    menuButton: menu && /*#__PURE__*/React.createElement("div", {
      "data-intercom-target": "Service Panel Overflow Menu",
      className: "no-page-breaks-on-print"
    }, menu),
    onCostChange: onCostChange,
    onHasError: onHasError,
    onDayOfMonthChange: onDayOfMonthChange,
    onDayOfWeekChange: onDayOfWeekChange,
    onBillUpfrontModeChange: onBillUpfrontModeChange
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, footer));
});
export default ServicePanel;